export const navigation = () => {
  const navbarToggler = document.querySelector('.navbar--toggler');
  const body = document.body;

  if (navbarToggler) {
    navbarToggler.addEventListener('click', () => {
      body.classList.toggle('menu-is-open');
    });
  }
};
